/* eslint-disable max-len */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { CategoryFilterOverlay as SourceCategoryFOC } from 'SourceComponent/CategoryFilterOverlay/CategoryFilterOverlay.component';

import './CategoryFilterOverlay.style';
/** @namespace Mspwa/Component/CategoryFilterOverlay/Component/CategoryFilterOverlayComponent */
export class CategoryFilterOverlayComponent extends SourceCategoryFOC {
    renderHeading() {
        return (
            <h3 block="CategoryFilterOverlay" elem="Heading">
                { __('Filter by') }
            </h3>
        );
    }
}

export default CategoryFilterOverlayComponent;
